<template>
    <div class="slm-filter slm-event-list__filter" v-click-outside="onClickOutside">
        <button class="slm-event-list__filter--toggle slm-expander-button" :aria-expanded="show ? 'true' : 'false'" @click="show = !show">
            <span class="slm-event-list__filter--toggle-title">
                {{filters.title}}
            </span>
        </button>
        <div class="slm-filter--wrapper slm-event-list__filter--wrapper" :class="show ? 'show' : ''">
            <div class="slm-event-list__filter--options">
                <label class="slm-event-list__filter--option slm-checkbox-item">
                    <input class="show-for-sr" type="checkbox" name="all" value="alla" v-model="all" @change="allChanged()" :disabled="all"/>
                    <span class="slm-checkbox-item__checkbox"></span>
                    <span class="slm-checkbox-item__text">{{filters.showAll}}</span>
                </label>
                <label v-for="option in filters.options" :key="option.value" class="slm-event-list__filter--option slm-checkbox-item">
                    <input class="show-for-sr" type="checkbox" :name="option.value" v-model="option.selected" @change="checkboxChanged"/>
                    <span class="slm-checkbox-item__checkbox"></span>
                    <span class="slm-checkbox-item__text">{{option.title}}</span>
                </label>
            </div>
            <button class="slm-link-button slm-event-list__filter--close" @click="show = false">Spara & stäng</button>
        </div>
    </div>
</template>
<script>

export default {
    name: 'filter-component',
    props: ['id', 'filters'],
    data() {
        return {
            show: false,
        }
    },
    methods: {
        allChanged() {
            this.$store.commit('resetFilter', this.id);
            this.$store.commit('setPage', {
                id: this.id,
                page: 1
            });
            this.$store.dispatch('setUrl');
            this.$store.dispatch('newSearch', this.id);
        },
        checkboxChanged() {
            this.$store.commit('setPage', {
                id: this.id,
                page: 1
            });
            this.$store.dispatch('setUrl');
            this.$store.dispatch('newSearch', this.id);
        },
        onClickOutside() {
            this.show = false;
        }
    },
    computed: {
        filterOptionSet() {
            return this.filters.options.some(option => option.selected);
        },
        all() {
            return !this.filters.options.some(option => option.selected);
        }
    },
}
</script>
